import React from 'react';
import { motion } from 'framer-motion';
import ProductMockup from './ProductMockup';
import { toolkitFiles } from '../data/toolkit';

function InsideSection() {
  return (
    <section className="inside section" id="inside">
      <div className="shell">
        <div className="section-heading">
          <div>
            <p className="eyebrow">What you get</p>
            <h2>Seven files. One system.</h2>
          </div>
          <p>150+ pages. Print what you need. Keep it open while you talk.</p>
        </div>

        <ProductMockup compact />

        <div className="file-list">
          {toolkitFiles.map((file, index) => (
            <motion.article
              className="file-card"
              key={file.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: Math.min(index * 0.06, 0.24) }}
            >
              <div className="file-number">{String(index + 1).padStart(2, '0')}</div>
              <div className="file-copy">
                <div className="file-title-row">
                  <h3>{file.label}</h3>
                  <span>{file.meta}</span>
                </div>
                <p>{file.description}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InsideSection;